import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `.action-menu {
	background: ${dt('actionMenu.background')};
}

.action-menu-title {
	font-size: ${dt('actionMenu.title.fontSize')};
	font-weight: ${dt('actionMenu.title.fontWeight')};
}
`;
